import "./index.scss";
const NoDisplay = () => {
    return(
        <div className="no-display"> 
            Landscape orientation and 850*590 minimum resolution required to display.
        </div>
    )
}

export default NoDisplay;